import { useIntl } from 'react-intl';
import { Field, Form, Formik } from 'formik';

import { contactFormSchema } from '../schemas';

import { contactApi } from '../api';

import Button from '../../../shared/ui/button/button';

import toast from 'react-hot-toast';

import styles from './contact-form.module.css';

export function ContactForm() {
	const intl = useIntl();

	return (
		<Formik
			initialValues={{
				full_name: '',
				email: '',
				message: '',
			}}
			validationSchema={contactFormSchema}
			className={styles.contactForm}
			onSubmit={async (values, { resetForm }) => {
				await contactApi(values);

				toast.success(intl.formatMessage({ id: 'ContactUsId34' }));

				resetForm();
			}}
		>
			{({ errors, touched }) => (
				<Form className={styles.contactForm}>
					<div className={styles.formGroup}>
						<label htmlFor='full_name' className={styles.label}>
							{intl.formatMessage({ id: 'ContactUsId6' })}
						</label>
						<Field
							type='text'
							id='full_name'
							name='full_name'
							autoComplete='full_name'
							className={styles.input}
							placeholder={intl.formatMessage({ id: 'ContactUsId7' })}
							aria-invalid={touched.full_name && !!errors.full_name}
							aria-describedby={
								touched.full_name && errors.full_name ? 'full_name' : undefined
							}
						/>
						{touched.full_name && errors.full_name && (
							<p id='username-error' className={styles.error}>
								{intl.formatMessage({ id: errors.full_name })}
							</p>
						)}
					</div>

					<div className={styles.formGroup}>
						<label htmlFor='email' className={styles.label}>
							{intl.formatMessage({ id: 'ContactUsId8' })}
						</label>
						<Field
							type='email'
							id='email'
							name='email'
							autoComplete='email'
							inputMode='email'
							className={styles.input}
							placeholder={intl.formatMessage({ id: 'ContactUsId9' })}
							aria-invalid={touched.email && !!errors.email}
							aria-describedby={
								touched.email && errors.email ? 'email-error' : undefined
							}
						/>
						{touched.email && errors.email && (
							<p id='email-error' className={styles.error}>
								{intl.formatMessage({ id: errors.email })}
							</p>
						)}
					</div>

					<div className={styles.formGroup}>
						<label htmlFor='message' className={styles.label}>
							{intl.formatMessage({ id: 'ContactUsId10' })}
						</label>
						<Field
							as='textarea'
							id='message'
							name='message'
							className={styles.textarea}
							placeholder={intl.formatMessage({ id: 'ContactUsId11' })}
							rows={4}
							aria-invalid={touched.message && !!errors.message}
							aria-describedby={
								touched.message && errors.message ? 'message-error' : undefined
							}
						/>

						{touched.message && errors.message && (
							<p id='message-error' className={styles.error}>
								{intl.formatMessage({ id: errors.message })}
							</p>
						)}
					</div>

					<Button type='submit' fullWidth>
						{intl.formatMessage({ id: 'ContactUsId12' })}
					</Button>
				</Form>
			)}
		</Formik>
	);
}
